import { render, staticRenderFns } from "./javaStudyPathWidge.vue?vue&type=template&id=16bc2a7c"
import script from "./javaStudyPathWidge.vue?vue&type=script&lang=js"
export * from "./javaStudyPathWidge.vue?vue&type=script&lang=js"
import style0 from "./javaStudyPathWidge.vue?vue&type=style&index=0&id=16bc2a7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports